export default __webpack_public_path__ + "static/media/bg.a3d260c7.jpg";